/** Rutas del módulo Gestión Despacho.
 * Clientes operativos: GET/POST/PUT/DELETE /api/despacho/clients (colección despacho_clients). */
export const DESPACHO_INICIO_PATH = "/despacho/inicio";

export const DESPACHO_MODULE_PATHS = new Set([
  "/despacho/inicio",
  "/despacho/clientes",
  "/despacho/auxiliares",
  "/despacho/tareas",
  "/despacho/calendario",
  "/despacho/mensajes",
  "/despacho/reportes",
  "/despacho/configuracion-modulo",
]);

export function isDespachoModulePath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (DESPACHO_MODULE_PATHS.has(path)) return true;
  return path.startsWith("/despacho/");
}
